import Chip from '@carvana/ds-chip';
import TagId from '~/constants/common/TagId';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import NotFoundSearchBar from './NotFoundSearchBar';

const pills = [
  { title: 'SUVs', link: '/cars/suv' },
  {
    title: 'Under $20k',
    link: generateSearchLinkFilter({ filters: { price: { max: 20000 } } })
  },
  {
    title: 'Electric & Hybrid',
    link: generateSearchLinkFilter({
      filters: { fuelTypes: ['Electric', 'Hybrid'] }
    })
  },
  {
    title: 'Low Mileage',
    link: generateSearchLinkFilter({
      filters: { tagIds: [TagId.LowMileage.toString()] }
    })
  },
  { title: 'Trucks', link: '/cars/truck' }
];

export default function NotFoundHero() {
  const getHref = useGetConsumerHref();

  return (
    <div className="border-b border-border-subtle bg-background-default px-[20px] pb-4xl pt-[36px] md:px-4xl md:pb-6xl md:pt-[72px]">
      <div className="mx-auto flex max-w-[800px] flex-col items-center gap-[20px] text-center">
        <h1 className="text-text-strong t-brand-md uppercase sm:t-brand-lg">
          Looks like <br className="block sm:hidden" /> this road{' '}
          <br className="hidden sm:block" />
          hit <br className="block sm:hidden" /> a dead end.
        </h1>
        <p className="text-text-default t-body-lg">
          There are still thousands of cars ready for delivery. Start a new
          search below, or browse by body style, budget, or model.
        </p>

        <div className="mt-md w-full">
          <NotFoundSearchBar />
        </div>

        <div
          className="mt-sm flex flex-wrap justify-center gap-sm"
          data-testid="not-found-category-pills"
        >
          {pills.map(({ title, link }) => (
            <a
              key={title}
              href={getHref(link)}
              data-analytics-id="Not Found Category Pill"
              data-analytics-attributes={JSON.stringify({
                description: 'Not found category pill',
                content: title
              })}
              data-testid="not-found-category-pill"
            >
              <Chip shape="pill" size="default">
                {title}
              </Chip>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
